import React, { useEffect, useState } from "react";
import { Pagination, Spin } from "antd";
import { fetchEntries, changePage } from "../../../redux/slice/entriesSlice";
import { GoBack, HeaderText, MainLayout } from "@/components";
import "./tables.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

function LeadTableOne() {
  const { rowData, isLoading, pageSize, currentPage, totalEntries } = useSelector(
    (state) => state.entries
  );
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const buildingId = pathSegments[pathSegments.length - 1];
  const dispatch = useDispatch();
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (buildingId) {
      dispatch(fetchEntries(buildingId));
    }
  }, [buildingId, dispatch]);

  useEffect(() => {
    const filtered = rowData.filter((data) => {
      const locationFields = [
        data.Room_Name,
        data.Wall,
        data.Structure,
        data.Location,
      ]
        .filter((item) => item !== "N/A" && item)
        .join(" ");

      const descriptionFields = [
        data.Paint_Condition,
        data.Substrate,
        data.Color,
      ]
        .filter((item) => item !== "N/A" && item)
        .join(" ");

      return locationFields || descriptionFields;
    });

    setFilteredData(filtered);
  }, [rowData]);

  // entries.currentPage is shared by all four lead screens and was never reset,
  // so opening a second building after paging through the first issued
  // skip=<old offset> and rendered an empty table with no error.
  useEffect(() => {
    return () => {
      dispatch(changePage({ page: 1, pageSize: 10 }));
    };
  }, [dispatch]);

  const handlePageChange = (page, size) => {
    dispatch(changePage({ page, pageSize: size }));
    dispatch(fetchEntries(buildingId));
  };

  return (
    <MainLayout>
      <div className="table-two-wrapper">
        <HeaderText>
          <GoBack />
          Table 1 · <span className="header-light-text">{buildingId}</span>
        </HeaderText>
        <div className="table-wrapper">
          {isLoading ? (
            <Spin delay={20} fullscreen size="large" />
          ) : (
            <div className="table-wrapper">
              <div
                className="table-overflow-wrapper container p-0"
                id="customScrollTable"
              >
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={{ width: "50%" }}>
                        Location of Homogenous Areas
                      </th>
                      <th style={{ width: "50%" }}>
                        Description of Homogenous Areas
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((data, index) => {
                      const locationFields = [
                        data.Room_Name,
                        data.Wall,
                        data.Structure,
                        data.Location,
                      ]
                        .filter((item) => item !== "N/A" && item)
                        .join(" ");

                      const descriptionFields = [
                        data.Paint_Condition,
                        data.Substrate,
                        data.Color,
                      ]
                        .filter((item) => item !== "N/A" && item)
                        .join(" ");

                      return (
                        <tr key={index}>
                          <td style={{ width: "50%" }}>{locationFields}</td>
                          <td style={{ width: "50%" }}>{descriptionFields}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        {/*
          The list is paginated server-side, so rowData holds at most one page and
          filteredData is a subset of it -- `filteredData.length > 10` was never
          true and the pager never rendered, leaving every reading after the first
          page unreachable on a compliance table. Gate on the server total, as
          table_two does.
        */}
        {!isLoading && totalEntries > pageSize && (
          <div className="pagination">
            <Pagination
              current={currentPage}
              total={totalEntries}
              pageSize={pageSize}
              onChange={handlePageChange}
              defaultCurrent={1}
              defaultPageSize={10}
              showSizeChanger
            />
          </div>
        )}
      </div>
    </MainLayout>
  );
}

export default LeadTableOne;
